<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="applyContent">
      <div v-if="businessPermissions.length === 0" class="applyNoData">
        <div class="noDataBox">
          <div class="noData"></div>
          <div class="noDataTest">无当前系统操作权限</div>
        </div>
      </div>
      <div v-for="(item, index) in businessPermissions" :key="index">
        <div class="authority-apply clearfix">
          <div class="authority-apply-item l clearfix">
            <div class="flex justify-content-space-between align-items-center">
              <span class="otitle">{{ item.contentBusinessName }}</span>

              <span class="status audit" v-if="item.auditStatus === 1"
                >审核中</span
              >
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                class="status reject"
                v-if="item.auditStatus === 3"
                :content="item.auditRemarks"
              >
                <span slot="reference" class="el-icon-question">被驳回</span>
              </el-popover>
              <span
                class="status arealyOpen"
                v-if="item.auditStatus === 2 && item.accountStatus !== 3"
                >已开通
              </span>
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                class="status alreadyFreeze"
                v-if="item.accountStatus === 3"
                :content="item.auditRemarks"
              >
                <span slot="reference" class="el-icon-question">冻结</span>
              </el-popover>
            </div>
            <p class="authority-apply-item-content">
              {{ item.introduction }}
            </p>
            <span
              class="btn-apply-authority"
              v-if="item.auditStatus === 0"
              @click="applyRight(item)"
              >申请权限</span
            >
            <span
              class="btn-alreadyApply-authority"
              v-if="item.auditStatus !== 0 && item.auditStatus !== 3"
              >申请权限</span
            >
            <span
              class="btn-apply-authority"
              v-if="item.auditStatus === 3"
              @click="applyRight(item)"
              >重新申请</span
            >
          </div>
        </div>
      </div>
    </div>

    <modal
      :isShow.sync="formData.isShowApplyModal"
      title="申请权限"
      :width="width"
      :isShowBtn="formData.isShowBtn"
      :btnText="formData.btnTextModal"
      @clickHandler="ShowApplyClick"
    >
      <el-form
        :model="formData"
        label-width="100px"
        class="demo-ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="业务名称" prop="targetLineInfo.applyRemarks">
          <span>{{ formData.bassinessName }}</span>
        </el-form-item>
        <el-form-item label="申请理由" prop="applyReason" class="ApplyDom">
          <el-input
            size="small"
            type="textarea"
            placeholder="请输入"
            v-model="formData.applyReason"
            maxlength="150"
            show-word-limit
            class="ApplyInp"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>

<script>
import breadCrumb from "../../../../components/breadCrumb";
import modal from "../../../../components/modal";
import {
  pageBusinessPermissionsApply, //分页查询运营人员业务权限列表
  applyBusinessPermission, //申请业务权限
} from "../../../../api/man";

export default {
  name: "authorityApply",
  components: {
    breadCrumb,
    modal,
  },
  data() {
    return {
      rules: {
        applyReason: [
          { required: true, message: "请填写理由", trigger: "blur" },
        ],
      },
      dialogShow: true,
      width: "414px",
      businessPermissions: [],
      formData: {
        isShowApplyModal: false,
        isShowBtn: [true, true],
        btnTextModal: ["取消", "提交"],
        applyReason: "",
        bassinessName: "",
        id: "",
        targetTenantId: "",
      },
    };
  },
  methods: {
    dialogHandel(data) {
      this.dialogShow = data;
    },
    applyRight(item) {
      this.formData.isShowApplyModal = true;
      this.formData.id = item.id;
      this.formData.targetTenantId = item.tenantId;
      this.formData.bassinessName = item.contentBusinessName;
    },
    ShowApplyClick(arg) {
      if (arg === "one") {
        this.formData.isShowApplyModal = false;
      } else if (arg === "two") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.getApplyBusinessPermission();
            this.formData.isShowApplyModal = false;
          } else {
            return false;
          }
        });
      }
      this.formData.applyReason = "";
      this.formData.targetTenantId = "";
      this.formData.targetTenantId = "";
    },
    //分页查询运营人员业务权限列表
    getPageBusinessPermissionsApply() {
      pageBusinessPermissionsApply({
        tenantId: this.$commonJs.getTenantId(),
        pageSize: 100000,
      }).then((res) => {
        this.businessPermissions = res.data;
      });
    },
    getApplyBusinessPermission(contentUserManId, tenantId) {
      applyBusinessPermission({
        tenantId: this.$commonJs.getTenantId(),
        contentBusinessId: this.formData.id,
        applyRemarks: this.formData.applyReason,
      })
        .then((res) => {
          this.getPageBusinessPermissionsApply();
        })
        .catch((err) => {});
    },
  },
  created() {
    this.getPageBusinessPermissionsApply();
  },
};
</script>

<style scoped lang="scss">
.authority-apply {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  /*padding: 26px 0 26px 24px;*/
  margin-right: 20px;
  margin-bottom: 20px;
  &-item {
    width: 273px;
    height: 190px;
    border: 1px dashed #000;
    padding: 28px 20px 20px 20px;
    position: relative;
    .otitle {
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: rgba(44, 52, 67, 1);
      line-height: 18px;
    }
    .status {
      font-size: 14px;
    }
    .pass {
      color: rgba(4, 183, 153, 1);
    }
    .reject {
      color: rgba(246, 36, 88, 1);
      cursor: pointer;
    }
    .audit {
      color: rgba(38, 108, 238, 1);
    }
    .arealyOpen {
      color: #04b799;
    }
    .alreadyFreeze {
      color: #f62458;
      cursor: pointer;
    }
    &-content {
      margin: 20px 0;
      width: 235px;
      height: 72px;
      font-size: 14px;
      color: rgba(93, 96, 114, 1);
      overflow: hidden;
      line-height: 18px;
      overflow-y: auto;
      word-break: break-all;
      cursor: pointer;
    }
    .btn-apply-authority,
    .btn-alreadyApply-authority {
      font-size: 14px;
      color: #266cee;
      cursor: pointer;
      position: absolute;
      right: 20px;
      bottom: 20px;
    }
    .btn-alreadyApply-authority {
      color: #c3cbd6;
    }
  }
}
.applyContent {
  display: -webkit-box;
  flex-direction: column;
  flex-wrap: wrap;
  -webkit-box-orient: horizontal;
  // max-height: 480px;
  height: auto;
  min-width: 1208px;
  // overflow: auto;
  background: rgba(255, 255, 255, 1);
  padding: 26px 23px 50px 25px;
}
.applyNoData {
  width: 1208px;
  height: 480px;
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  position: relative;
  .noDataBox {
    position: absolute;
    width: 173px;
    height: 155px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    .noData {
      width: 173px;
      height: 111px;
      background: url("../../../../assets/noData2.png");
      background-repeat: no-repeat;
    }
    .noDataTest {
      display: block;
      /*width: 104px;*/
      text-align: center;
      height: 14px;
      line-height: 14px;
      font-size: 12px;
      color: rgba(156, 168, 185, 1);
      margin-top: 29px;
    }
  }
}

:deep(.el-textarea__inner) {
  min-height: 130px !important;
  resize: none;
}
:deep(.el-input__inner) {
  width: 276px;
}

:deep(.modal-body) {
  margin-top: 30px;
}
.ApplyDom {
  margin-top: 30px;
  .ApplyInp {
    max-height: 130px;
    max-width: 276px;
    overflow: hidden;
  }
}
</style>
